import { Button, Divider, Dropdown, Layout, Typography } from 'antd';
import { Header } from 'antd/es/layout/layout.js';
import { Link, useNavigate } from 'react-router-dom';
import {
  DownloadOutlined,
  DownOutlined,
  LogoutOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import style from './ContentContainer.module.css';
import QalaAI from './QalaAI.jsx';
import { $userInfo, logoutEv } from '../../models/authModel/index.js';
import CitySelector from '../CitySelector/CitySelector.jsx';
import {
  $language,
  changeLanguageEv,
  downloadEv,
} from '../../models/logicModel/index.js';

const { Title } = Typography;

function ContentContainer({ children }) {
  const userInfo = useUnit($userInfo);
  const navigate = useNavigate();
  const logout = useUnit(logoutEv);
  const language = useUnit($language);
  const changeLanguage = useUnit(changeLanguageEv);
  const download = useUnit(downloadEv);
  const { t } = useTranslation();

  const profileMenu = [];
  profileMenu.push({
    key: 'logout',
    label: (
      <>
        <LogoutOutlined /> {t('exit')}
      </>
    ),
  });

  const onDropdownClick = ({ key }) => {
    if (key === 'logout') {
      logout();
    }
  };

  const languageItems = [
    {
      key: 'ru',
      label: 'Ру',
    },
    {
      key: 'en',
      label: 'En',
    },
  ];

  return (
    <Layout>
      <Header className={style.header}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Title className={style.title} level={1}>
            RESILIENT CITY PLATFORM
          </Title>
          <Divider
            type="vertical"
            style={{
              height: '20px',
              margin: '0px 20px',
              borderInlineStart: '1px solid #D3D3D3',
            }}
          />
          <Link
            to="https://qala-ai.com/"
            target="_blank"
            style={{
              height: 'unset',
              lineHeight: 'normal',
              color: 'black',
            }}
          >
            <QalaAI />
            {/* <img src={logo} /> */}
          </Link>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', columnGap: 10 }}>
          <Button onClick={download}>{t('download')}</Button>
          <CitySelector />
          <Dropdown menu={{ items: languageItems, onClick: changeLanguage }}>
            <div style={{ cursor: 'pointer' }}>{language}</div>
          </Dropdown>
          <Dropdown
            trigger="click"
            menu={{ items: profileMenu, onClick: onDropdownClick }}
            placement="bottomRight"
          >
            <div className="profile_box">
              <UserOutlined style={{ marginRight: '5px' }} />
              {userInfo?.email}
              <DownOutlined style={{ marginLeft: '5px' }} />
            </div>
          </Dropdown>
        </div>
      </Header>
      {children}
    </Layout>
  );
}

export default ContentContainer;
